<template>
  <div class="nh">
    <!-- ============================ HERO DESKTOP ============================ -->
    <section v-responsive.lg.xl class="nh-hero">
      <div class="nh-hero__bg" aria-hidden="true">
        <span class="nh-hero__orb nh-hero__orb--orange"></span>
        <span class="nh-hero__orb nh-hero__orb--blue"></span>
        <span class="nh-hero__dots"></span>
        <span class="nh-hero__grid-lines"></span>
      </div>

      <div class="nh-hero__container">
        <div class="nh-hero__grid">
          <div class="nh-hero__content">
            <div class="nh-eyebrow reveal">
              <i class="fas fa-award"></i>
              <span>{{ $t('home_page.cima_agree[0]') }} <strong>{{ $t('home_page.cima_agree[1]') }}</strong></span>
            </div>

            <h1 class="nh-hero__title reveal">
              <span>{{ $t('home_page.Home_titre') }}</span>&nbsp;
              <span class="nh-rotor-wrap">
                <span class="nh-rotor">
                  <span class="nh-rotor__line" v-for="(word, i) in rotatingWords" :key="i">{{ word }}</span>
                </span>
              </span>
            </h1>

            <p class="nh-hero__subtitle reveal">
              {{ $t('home_page.Descriptif_message[0]') }}<br />
              {{ $t('home_page.Descriptif_message[1]') }}
            </p>

            <div class="nh-hero__actions reveal">
              <div class="nh-dd nh-dd--primary" :class="{ 'is-open': devisOpen }">
                <button type="button" class="nh-dd__btn" @click="toggleMenu('devisOpen')">
                  <img class="nh-dd__btn-icon" loading="lazy" src="../assets/img/writing.png" alt="" />
                  <span>{{ $t('home_page.bouton_devis[0]') }}</span>
                  <i class="fas fa-chevron-down nh-dd__chevron"></i>
                </button>
                <div class="nh-dd__menu">
                  <div v-for="(group, gi) in devisItems" :key="'g' + gi">
                    <p class="nh-dd__group">{{ group.label }}</p>
                    <a
                      v-for="(item, ii) in group.items"
                      :key="'i' + gi + ii"
                      :href="item.href"
                      class="nh-dd__item"
                      @click="closeMenus"
                    >
                      <img :src="item.icon" width="34" height="34" :alt="item.label" />
                      <span>{{ item.label }}</span>
                    </a>
                  </div>
                </div>
              </div>

              <div class="nh-dd nh-dd--secondary" :class="{ 'is-open': simulationOpen }">
                <button type="button" class="nh-dd__btn" @click="toggleMenu('simulationOpen')">
                  <img class="nh-dd__btn-icon" loading="lazy" src="../assets/img/rocket.png" alt="" />
                  <span>{{ $t('home_page.bouton_simulation_view') }}</span>
                  <i class="fas fa-chevron-down nh-dd__chevron"></i>
                </button>
                <div class="nh-dd__menu">
                  <a
                    v-for="(item, i) in simulationItems"
                    :key="'s' + i"
                    :href="item.href"
                    class="nh-dd__item"
                    @click="closeMenus"
                  >
                    <img :src="item.icon" width="34" height="34" :alt="item.label" />
                    <span>{{ item.label }}</span>
                  </a>
                </div>
              </div>
            </div>

            <div class="nh-hero__stats reveal">
              <div class="nh-stat">
                <span class="nh-stat__icon nh-stat__icon--orange"><i class="fas fa-stopwatch"></i></span>
                <span class="nh-stat__text">
                  <strong>2 min</strong>
                  <small>{{ $t('home_page.Descriptif_message[0]') }}</small>
                </span>
              </div>
              <div class="nh-stat">
                <span class="nh-stat__icon nh-stat__icon--blue"><i class="fas fa-globe"></i></span>
                <span class="nh-stat__text">
                  <strong>100% en ligne</strong>
                  <small>{{ $t('home_page.Descriptif_message_mobile[0]') }}</small>
                </span>
              </div>
              <div class="nh-stat">
                <span class="nh-stat__icon nh-stat__icon--orange"><i class="fas fa-star"></i></span>
                <span class="nh-stat__text">
                  <strong>4,6/5</strong>
                  <small>{{ $t('home_page.cima_agree[7]') }}</small>
                </span>
              </div>
            </div>
          </div>

          <div class="nh-hero__visual reveal">
            <div class="nh-hero__rings" aria-hidden="true">
              <span class="nh-hero__ring nh-hero__ring--outer"></span>
              <span class="nh-hero__ring nh-hero__ring--inner"></span>
            </div>

            <div class="nh-hero__blob">
              <img :src="mascot" alt="Kiray, la mascotte Assuraf" class="nh-hero__mascot" />
            </div>

            <div class="nh-hero__card nh-hero__card--rating">
              <div class="nh-hero__stars">
                <i class="fas fa-star" v-for="s in 5" :key="s"></i>
              </div>
              <p>{{ $t('home_page.cima_agree[7]') }}</p>
            </div>

            <div class="nh-hero__card nh-hero__card--cima">
              <i class="fas fa-award"></i>
              <p>
                <strong>{{ $t('home_page.cima_agree[0]') }} {{ $t('home_page.cima_agree[1]') }}</strong>
                <small>{{ $t('home_page.cima_agree[2]') }}</small>
              </p>
            </div>

            <div class="nh-hero__card nh-hero__card--online">
              <i class="fas fa-check-circle"></i>
              <p>
                <strong>100% en ligne</strong>
                <small>{{ $t('home_page.Descriptif_message_mobile[1]') }}</small>
              </p>
            </div>

            <div class="nh-hero__float nh-hero__float--rocket" aria-hidden="true">
              <img loading="lazy" src="../assets/img/rocket.png" alt="" />
            </div>
            <div class="nh-hero__float nh-hero__float--shield" aria-hidden="true">
              <i class="fas fa-shield-alt"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="nh-hero__scroll" aria-hidden="true"><span></span></div>
    </section>

    <!-- ============================ HERO MOBILE ============================ -->
    <section v-responsive.sm.xs class="nh-hero-m">
      <div class="nh-hero-m__bg" aria-hidden="true">
        <span class="nh-hero__orb nh-hero__orb--orange"></span>
        <span class="nh-hero__orb nh-hero__orb--blue"></span>
        <span class="nh-hero__dots"></span>
      </div>

      <div class="nh-hero-m__container">
        <div class="nh-eyebrow reveal">
          <i class="fas fa-award"></i>
          <span>{{ $t('home_page.cima_agree[0]') }} <strong>{{ $t('home_page.cima_agree[1]') }}</strong></span>
        </div>

        <h1 class="nh-hero-m__title reveal">
          <span>{{ $t('home_page.Home_titre') }}</span>&nbsp;
          <span class="nh-rotor-wrap">
            <span class="nh-rotor">
              <span class="nh-rotor__line" v-for="(word, i) in rotatingWords" :key="i">{{ word }}</span>
            </span>
          </span>
        </h1>

        <p class="nh-hero-m__subtitle reveal">
          {{ $t('home_page.Descriptif_message_mobile[0]') }}<br />
          {{ $t('home_page.Descriptif_message_mobile[1]') }}<br />
          {{ $t('home_page.Descriptif_message_mobile[2]') }}
        </p>

        <div class="nh-hero-m__actions reveal">
          <div class="nh-dd nh-dd--primary" :class="{ 'is-open': devisOpen }">
            <button type="button" class="nh-dd__btn" @click="toggleMenu('devisOpen')">
              <img class="nh-dd__btn-icon" loading="lazy" src="../assets/img/writing.png" alt="" />
              <span>{{ $t('home_page.bouton_devis[0]') }}</span>
              <i class="fas fa-chevron-down nh-dd__chevron"></i>
            </button>
            <div class="nh-dd__menu">
              <div v-for="(group, gi) in devisItems" :key="'mg' + gi">
                <p class="nh-dd__group">{{ group.label }}</p>
                <a
                  v-for="(item, ii) in group.items"
                  :key="'mi' + gi + ii"
                  :href="item.href"
                  class="nh-dd__item"
                  @click="closeMenus"
                >
                  <img :src="item.icon" width="34" height="34" :alt="item.label" />
                  <span>{{ item.label }}</span>
                </a>
              </div>
            </div>
          </div>

          <div class="nh-dd nh-dd--secondary" :class="{ 'is-open': simulationOpen }">
            <button type="button" class="nh-dd__btn" @click="toggleMenu('simulationOpen')">
              <img class="nh-dd__btn-icon" loading="lazy" src="../assets/img/rocket.png" alt="" />
              <span>{{ $t('home_page.bouton_simulation_view') }}</span>
              <i class="fas fa-chevron-down nh-dd__chevron"></i>
            </button>
            <div class="nh-dd__menu">
              <a
                v-for="(item, i) in simulationItems"
                :key="'ms' + i"
                :href="item.href"
                class="nh-dd__item"
                @click="closeMenus"
              >
                <img :src="item.icon" width="34" height="34" :alt="item.label" />
                <span>{{ item.label }}</span>
              </a>
            </div>
          </div>
        </div>

        <div class="nh-hero-m__stats reveal">
          <div class="nh-stat">
            <span class="nh-stat__icon nh-stat__icon--orange"><i class="fas fa-stopwatch"></i></span>
            <span class="nh-stat__text"><strong>2 min</strong></span>
          </div>
          <div class="nh-stat">
            <span class="nh-stat__icon nh-stat__icon--blue"><i class="fas fa-globe"></i></span>
            <span class="nh-stat__text"><strong>100% en ligne</strong></span>
          </div>
          <div class="nh-stat">
            <span class="nh-stat__icon nh-stat__icon--orange"><i class="fas fa-star"></i></span>
            <span class="nh-stat__text"><strong>4,6/5</strong></span>
          </div>
        </div>

        <div class="nh-hero-m__visual reveal">
          <div class="nh-hero-m__blob">
            <img :src="mascot" alt="Kiray, la mascotte Assuraf" class="nh-hero-m__mascot" />
          </div>
          <div class="nh-hero__card nh-hero__card--rating">
            <div class="nh-hero__stars">
              <i class="fas fa-star" v-for="s in 5" :key="s"></i>
            </div>
            <p>{{ $t('home_page.cima_agree[7]') }}</p>
          </div>
          <div class="nh-hero__card nh-hero__card--cima">
            <i class="fas fa-award"></i>
            <p>
              <strong>{{ $t('home_page.cima_agree[0]') }} {{ $t('home_page.cima_agree[1]') }}</strong>
              <small>{{ $t('home_page.cima_agree[2]') }}</small>
            </p>
          </div>
        </div>
      </div>
    </section>

    <!--PARITE DES ASSURANCES-->
    <assuranceSection></assuranceSection>

    <!--PARTIE POURQUOI CHOISIR ASSURAF-->
    <pourquoiSection></pourquoiSection>

    <!--CIMA SECTION ASSURAF-->
    <cimaSection></cimaSection>

    <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
    <partenaireSection type="base"></partenaireSection>

    <!--PARTIE MASCOTE KIRRAY-->
    <appMobileSection></appMobileSection>

    <!--PARTIE NOTRE PLATEFORME -->
    <plateformeSection></plateformeSection>

    <!--PARITE CE QUE DISENTS NOS CLIENTS-->
<!--    <testimonialSection></testimonialSection>-->

    <!--PARITE DEJA ASSURE-->
    <alreadyInsuredSection></alreadyInsuredSection>

    <!--PARITE NEWSLETTER-->
    <newsletterSection></newsletterSection>

    <!--PARITE PAIEMENT-->
    <paymentParterSection></paymentParterSection>
  </div>
</template>

<script>
import Api from '../services/Api';
import store from "../store/store";
import assuranceSection from './home_component/new_home/assurance_section.vue'
import pourquoiSection from './home_component/new_home/pourquoi_section.vue'
import partenaireSection from './home_component/new_home/partenaire_section.vue'
import appMobileSection from './home_component/new_home/app_mobile_section.vue'
import plateformeSection from './home_component/new_home/plateforme_section.vue'
import newsletterSection from './home_component/new_home/newsletters_section.vue'
import paymentParterSection from './home_component/new_home/payment_partner_component.vue'
import cimaSection from './home_component/new_home/cima_section.vue'
import alreadyInsuredSection from './home_component/new_home/already_insured.vue';

export default {
  name: 'NewHome',
  components: {
    assuranceSection,
    pourquoiSection,
    partenaireSection,
    appMobileSection,
    plateformeSection,
    newsletterSection,
    paymentParterSection,
    cimaSection,
    alreadyInsuredSection
  },
  data: () => ({
    email: '',
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    maketpopup: false,
    objetMarketingPopup: null,
    To_check_MaketPopup_State: null,
    devisOpen: false,
    simulationOpen: false
  }),

  computed: {
    mascot() {
      return require('../assets/img/home/new_home/Mascot_assuraf.png');
    },
    rotatingWords() {
      return this.$t('home_page.Home_titre_2');
    },
    devisItems() {
      return [
        {
          label: this.$t('home_page.particulier_label'),
          items: [
            { href: '/devis/auto', icon: require('../assets/img/icones/menu/cars_quote.png'), label: this.$t('home_page.bouton_devis[1]') },
            { href: '/devis/habitation', icon: require('../assets/img/icones/menu/house_quote.png'), label: this.$t('home_page.bouton_devis[2]') },
            { href: '/devis/voyage', icon: require('../assets/img/icones/menu/travel_quote.png'), label: this.$t('home_page.bouton_devis[3]') },
            { href: '/devis/sante', icon: require('../assets/img/icones/menu/health_quote.png'), label: this.$t('home_page.bouton_devis[4]') },
            { href: '/devis/vie', icon: require('../assets/img/icones/menu/life_quote.png'), label: this.$t('home_page.bouton_devis[5]') },
            { href: '/plus', icon: require('../assets/img/icones/menu/add_quote.png'), label: this.$t('home_page.bouton_devis[6]') }
          ]
        },
        {
          label: this.$t('home_page.entreprise_label'),
          items: [
            { href: '/flotte/entreprise', icon: require('../assets/img/icones/menu/cars_quote.png'), label: this.$t('menu.Devis[7]') },
            { href: '/devis/mrp', icon: require('../assets/img/icones/menu/mrp_quote.png'), label: 'MRP' },
            { href: '/devis/trc', icon: require('../assets/img/icones/menu/trc_quote.png'), label: 'TRC' },
            { href: '/rcscolaire', icon: require('../assets/img/icones/rcscolaire.png'), label: this.$t('menu.Devis[8]') }
          ]
        }
      ];
    },
    simulationItems() {
      return [
        { href: '/simulate/devis/auto', icon: require('../assets/img/icones/menu/cars_quote.png'), label: this.$t('home_page.bouton_devis[1]') },
        { href: '/simulate/devis/voyage', icon: require('../assets/img/icones/menu/travel_quote.png'), label: this.$t('home_page.bouton_devis[3]') }
      ];
    }
  },

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    checkToken() {
      Api().get('user/check/token')
          .then((resultat) => {
            if (!resultat.data.ok) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
        if (err.response.data.ok === false) {
          store.state.isUserLoggedIn = false;
          store.dispatch("setUser", {});
          store.dispatch("setToken", {});
          this.showLoginForm = true
        }
      });
    },

    ShowMarketPopup() {
      let uripage = this.$route.path;
      Api().post('popup/getpopup', {pagetoshowon: uripage})
          .then(resp => {
            if (resp.data.popup.length > 0) {
              if (!this.To_check_MaketPopup_State) {
                this.maketpopup = true;
                this.objetMarketingPopup = resp.data.popup
              }
            }
          })
    },

    getCookie: function () {
      const match = document.cookie.match(new RegExp('(^| )popup_marketing_checked_Home=([^;]+)'));
      if (typeof match == 'object' && match != null) {
        this.To_check_MaketPopup_State = match
      } else {
        this.To_check_MaketPopup_State = false
      }
    },

    toggleMenu(name) {
      this[name] = !this[name];
    },

    closeMenus() {
      this.devisOpen = false;
      this.simulationOpen = false;
    },

    initReveal() {
      const els = this.$el.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        els.forEach(el => el.classList.add('is-visible'));
        return;
      }
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this._observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach(el => this._observer.observe(el));
    }
  },

  beforeDestroy() {
    if (this._observer) {
      this._observer.disconnect();
    }
    window.removeEventListener('scroll', this.handleParallax);
    window.removeEventListener('resize', this.updateParallaxOffsets);
  },

  mounted() {
    window.scrollTo(0, 0);
    this.checkToken();
    this.ShowMarketPopup();
    this.getCookie();
    this.$nextTick(() => this.initReveal());
  }
}
</script>

<style lang="less" scoped>

@import "../assets/less/config";

.nh {
  overflow-x: hidden;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

/* ============================================================
   TOKENS
   ============================================================ */
.nh-hero,
.nh-hero-m {
  --c-orange: #ffa409;
  --c-orange-dark: #f57c00;
  --c-orange-soft: #fff3df;
  --c-blue: #5B94BC;
  --c-blue-dark: #3d7ba6;
  --c-blue-soft: #eaf3f9;
  --c-ink: #2b2b2b;
  --c-muted: #898d8f;
  --c-grey: #59595b;
  --c-cream: #FFFBF6;
}

/* ============================================================
   EYEBROW + ROTOR (partagés desktop/mobile)
   ============================================================ */
.nh-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid rgba(255, 164, 9, 0.35);
  box-shadow: 0 8px 20px rgba(255, 164, 9, 0.12);
  color: #b06d00;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 9px 18px;
  border-radius: 999px;
  margin-bottom: 24px;

  i {
    font-size: 18px;
    color: #ffa409;
  }

  strong {
    font-weight: 800;
    color: #ffa409;
  }
}

.nh-rotor-wrap {
  display: inline-block;
  overflow: hidden;
  vertical-align: bottom;
  height: 1.14em;
}

.nh-rotor {
  display: block;
  animation: nh-rotor 12s cubic-bezier(0.7, 0, 0.3, 1) infinite;

  &__line {
    display: block;
    height: 1.14em;
    line-height: 1.14em;
    white-space: nowrap;
    background: linear-gradient(92deg, #ffa409 0%, #f57c00 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

@keyframes nh-rotor {
  0%, 20% { transform: translateY(0); }
  25%, 45% { transform: translateY(-25%); }
  50%, 70% { transform: translateY(-50%); }
  75%, 95% { transform: translateY(-75%); }
  100% { transform: translateY(0); }
}

/* ============================================================
   HERO DESKTOP
   ============================================================ */
.nh-hero {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 150px 32px 96px;
  box-sizing: border-box;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: linear-gradient(160deg, #FFFBF6 0%, #fff5e6 45%, #eef6fb 100%);
  }

  &__orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.55;

    &--orange {
      width: 480px;
      height: 480px;
      background: rgba(255, 164, 9, 0.32);
      top: -160px;
      right: -120px;
    }

    &--blue {
      width: 460px;
      height: 460px;
      background: rgba(91, 148, 188, 0.3);
      bottom: -180px;
      left: -140px;
    }
  }

  &__dots {
    position: absolute;
    top: 130px;
    left: 4%;
    width: 130px;
    height: 130px;
    background-image: radial-gradient(rgba(255, 164, 9, 0.5) 2px, transparent 2px);
    background-size: 24px 24px;
    opacity: 0.5;
  }

  &__grid-lines {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      linear-gradient(rgba(43, 43, 43, 0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(43, 43, 43, 0.04) 1px, transparent 1px);
    background-size: 56px 56px;
    -webkit-mask-image: radial-gradient(ellipse at 70% 30%, #000 0%, transparent 65%);
    mask-image: radial-gradient(ellipse at 70% 30%, #000 0%, transparent 65%);
  }

  &__container {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1.05fr 0.95fr;
    gap: 48px;
    align-items: center;
  }

  &__title {
    font-size: clamp(46px, 5.2vw, 68px);
    font-weight: 800;
    line-height: 1.14;
    letter-spacing: -1px;
    color: #2b2b2b;
    margin: 0;
  }

  &__subtitle {
    margin: 20px 0 0;
    font-size: 18px;
    line-height: 1.7;
    color: #59595b;
    max-width: 520px;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 36px;
  }

  &__stats {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 40px;
  }

  &__visual {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__rings {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__ring {
    position: absolute;
    border-radius: 50%;

    &--outer {
      width: 540px;
      height: 540px;
      border: 2px dashed rgba(255, 164, 9, 0.4);
      animation: nh-spin 40s linear infinite;
    }

    &--inner {
      width: 620px;
      height: 620px;
      border: 1px solid rgba(91, 148, 188, 0.35);
    }
  }

  &__blob {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 440px;
    aspect-ratio: 1 / 1;
    border-radius: 8%;
    background: linear-gradient(150deg, #fffdf7 0%, #fff1d8 55%, #ffe2b0 100%);
    border: 1px solid rgba(255, 164, 9, 0.25);
    box-shadow: 0 40px 80px -20px rgba(240, 136, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: nh-morph 14s ease-in-out infinite;
  }

  &__mascot {
    width: 116%;
    height: 116%;
    object-fit: contain;
    filter: drop-shadow(0 30px 30px rgba(43, 43, 43, 0.22));
  }

  &__card {
    position: absolute;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.82);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    box-shadow: 0 18px 40px rgba(43, 43, 43, 0.16);
    padding: 12px 16px;
    animation: nh-float 6s ease-in-out infinite;

    i {
      font-size: 22px;
    }

    p {
      margin: 0;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      font-weight: 800;
      color: #2b2b2b;
      line-height: 1.2;
    }

    small {
      font-size: 12px;
      font-weight: 600;
      color: #898d8f;
    }

    &--rating {
      top: 5%;
      left: 0;
      animation-delay: 0.6s;
      align-items: flex-start;
    }

    &--cima {
      bottom: 16%;
      left: -3%;
      animation-delay: 1.4s;

      i {
        color: #5B94BC;
      }
    }

    &--online {
      top: 16%;
      right: -2%;
      animation-delay: 2.2s;

      i {
        color: #ffa409;
      }
    }
  }

  &__stars {
    display: flex;
    gap: 2px;
    color: #ffa409;

    i {
      font-size: 16px;
    }
  }

  &__float {
    position: absolute;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 16px 34px rgba(43, 43, 43, 0.2);
    animation: nh-float 5s ease-in-out infinite;

    &--rocket {
      top: 24%;
      right: 10%;
      transform: rotate(15deg);
      animation-delay: 1s;

      img {
        width: 30px;
        height: 30px;
        object-fit: contain;
      }
    }

    &--shield {
      bottom: 26%;
      right: 16%;
      background: linear-gradient(135deg, #ffb33d, #f57c00);
      color: #fff;
      animation-delay: 1.8s;
    }
  }

  &__scroll {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: 26px;
    height: 44px;
    border: 2px solid rgba(43, 43, 43, 0.25);
    border-radius: 14px;
    display: flex;
    justify-content: center;
    padding-top: 8px;
    box-sizing: border-box;

    span {
      width: 4px;
      height: 9px;
      border-radius: 2px;
      background: #ffa409;
      animation: nh-wheel 1.8s ease-in-out infinite;
    }
  }
}

/* ============================================================
   HERO MOBILE
   ============================================================ */
.nh-hero-m {
  position: relative;
  overflow: hidden;
  padding: 110px 22px 56px;
  box-sizing: border-box;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: linear-gradient(160deg, #FFFBF6 0%, #fff5e6 45%, #eef6fb 100%);
  }

  &__container {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__title {
    font-size: 36px;
    font-weight: 800;
    line-height: 1.16;
    letter-spacing: -0.5px;
    color: #2b2b2b;
    margin: 0;
  }

  &__subtitle {
    margin: 18px 0 0;
    font-size: 16px;
    line-height: 1.7;
    color: #59595b;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    max-width: 420px;
    margin-top: 30px;

    .nh-dd__btn {
      width: 100%;
      justify-content: center;
      height: 56px;
      border-radius: 16px;
      font-size: 16px;
    }

    .nh-dd__menu {
      left: 0;
      right: 0;
      min-width: 0;
      max-height: 340px;
      overflow-y: auto;
    }
  }

  &__stats {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 30px;
  }

  &__visual {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 44px;
    width: 100%;
  }

  &__blob {
    position: relative;
    z-index: 2;
    width: 260px;
    aspect-ratio: 1 / 1;
    border-radius: 58% 42% 55% 45% / 55% 48% 52% 45%;
    background: linear-gradient(150deg, #fffdf7 0%, #fff1d8 55%, #ffe2b0 100%);
    border: 1px solid rgba(255, 164, 9, 0.25);
    box-shadow: 0 30px 60px -18px rgba(240, 136, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: nh-morph 14s ease-in-out infinite;
  }

  &__mascot {
    width: 116%;
    height: 116%;
    object-fit: contain;
    filter: drop-shadow(0 20px 24px rgba(43, 43, 43, 0.22));
  }

  .nh-hero__card {
    padding: 10px 14px;

    &--rating {
      top: -4%;
      left: 2%;
    }

    &--cima {
      bottom: 6%;
      right: 0;
      left: auto;
    }
  }
}

/* ============================================================
   STATS + DROPDOWNS
   ============================================================ */
.nh-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid rgba(43, 43, 43, 0.06);
  border-radius: 16px;
  padding: 14px 18px;
  box-shadow: 0 10px 24px rgba(43, 43, 43, 0.06);

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 22px;
    }

    &--orange {
      background: #fff3df;
      color: #ffa409;
    }

    &--blue {
      background: #eaf3f9;
      color: #5B94BC;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
    text-align: left;

    strong {
      font-size: 15px;
      color: #2b2b2b;
      white-space: nowrap;
    }

    small {
      font-size: 12px;
      color: #898d8f;
    }
  }
}

.nh-dd {
  position: relative;

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    height: 56px;
    padding: 0 24px;
    border: none;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
      transform: translateY(-3px);
    }
  }

  &--primary .nh-dd__btn {
    background: linear-gradient(135deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
    box-shadow: 0 14px 30px rgba(240, 136, 0, 0.35);
  }

  &--secondary .nh-dd__btn {
    background: linear-gradient(135deg, #7db6d4 0%, #5B94BC 50%, #3d7ba6 100%);
    box-shadow: 0 14px 30px rgba(61, 123, 166, 0.35);
  }

  &__btn-icon {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  &__chevron {
    font-size: 14px;
    transition: transform 0.25s ease;
  }

  &.is-open .nh-dd__chevron {
    transform: rotate(180deg);
  }

  &__menu {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    min-width: 260px;
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 24px 60px rgba(43, 43, 43, 0.18);
    padding: 10px;
    z-index: 50;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
  }

  &:hover .nh-dd__menu,
  &.is-open .nh-dd__menu {
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  &__group {
    margin: 8px 10px 4px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #898d8f;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 12px;
    text-decoration: none;
    color: #2b2b2b;
    font-weight: 600;
    font-size: 15px;
    transition: background 0.2s ease, transform 0.2s ease;

    &:hover {
      background: #fff3e0;
      transform: translateX(4px);
    }

    img {
      border-radius: 8px;
      background: #f7f8fa;
      padding: 4px;
      object-fit: contain;
      box-sizing: border-box;
    }
  }
}

/* ============================================================
   SCROLL-REVEAL
   ============================================================ */
.reveal {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.8s cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 0.8s cubic-bezier(0.22, 0.61, 0.36, 1);

  &.is-visible {
    opacity: 1;
    transform: none;
  }
}

.nh-hero__content .reveal:nth-child(2) { transition-delay: 0.08s; }
.nh-hero__content .reveal:nth-child(3) { transition-delay: 0.16s; }
.nh-hero__content .reveal:nth-child(4) { transition-delay: 0.24s; }
.nh-hero__content .reveal:nth-child(5) { transition-delay: 0.32s; }

/* ============================================================
   ANIMATIONS
   ============================================================ */
@keyframes nh-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes nh-spin {
  to { transform: rotate(360deg); }
}

@keyframes nh-morph {
  0%, 100% { border-radius: 58% 42% 55% 45% / 55% 48% 52% 45%; }
  50% { border-radius: 45% 55% 48% 52% / 52% 55% 45% 48%; }
}

@keyframes nh-wheel {
  0% { transform: translateY(0); opacity: 1; }
  70% { transform: translateY(12px); opacity: 0; }
  100% { opacity: 0; }
}

@media (max-width: 1200px) {
  .nh-hero {
    &__grid {
      grid-template-columns: 1fr 0.9fr;
      gap: 32px;
    }

    &__ring--inner { width: 520px; height: 520px; }
    &__ring--outer { width: 440px; height: 440px; }

    &__card--online { right: 0; }
  }
}

@media (max-width: 991px) {
  .nh-hero {
    min-height: auto;
    padding: 120px 24px 80px;
  }
}

@media (max-width: 600px) {
  .nh-stat {
    padding: 11px 14px;

    &__text small {
      display: none;
    }
  }
}

</style>

<style lang="less">
/* Animations d'apparition au scroll appliquées aussi aux sections enfants */
.reveal {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.8s cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 0.8s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.reveal.is-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
